<template>
  <Navigation :routes="routes"> <router-view></router-view> </Navigation>
</template>

<script>
import Navigation from "../../Admin/views/Navigation";
import routes from "../navigation.js";
import { routesToShow } from "@/helpers/functions";
export default {
  components: {
    Navigation,
  },
  mounted() {
    this.routes = routesToShow(this.routes, this.$user.getSubscription());
  },
  data() {
    return {
      routes,
    };
  },
};
</script>

<style>
.employee-home {
  background-color: var(--light-bg);
  min-height: 100vh;
  font-size: 14px;
  padding-bottom: 60px;
  color: #333;
  line-height: 26px;
  margin: -30px;
}

.employee-home .grid {
  display: grid;
  grid-template-areas:
    "header header header header"
    ". sidenav main .";
  grid-template-columns: 30px 330px 1fr 30px;
}

.employee-home .header {
  grid-area: header;
  min-height: 150px;
  background-color: var(--deep-blue);
}

.employee-home .sidenav {
  grid-area: sidenav;
  background-color: #fff;
  min-height: 100vh;
  margin-top: 20px;
}

.employee-home .sidenav > * {
  padding: 25px;
  border-bottom: 1px solid var(--border-color);
}

.employee-home .sidenav > *:last-child {
  border: none;
}

.employee-home .main {
  grid-area: main;
  min-height: 100vh;
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  column-count: 2;
  grid-gap: 20px;
  margin: 20px 0 20px 20px;
  align-items: flex-start;
  background-color: transparent !important;
}

.employee-home .card {
  background-color: #fff;
  color: #333;
  border-top: 2px solid var(--blue);
}

.employee-home .smaller {
  grid-column: 1 / span 4;
}

.employee-home .bigger {
  grid-column: 5/-1;
}

.employee-home .card-header {
  padding: 16px 25px;
  background-color: #fafafa;
  box-shadow: 0px 1px 1px #dadada;
}

.employee-home .card-body {
  display: inline-block;
  width: 100%;
  padding: 20px 25px 35px 25px;
}

.media-group {
  display: flex;
  align-items: center;
}

.media-group span {
  word-wrap: break-word;
}

.media-group:not(last-child) {
  margin-bottom: 5px;
}

.employee-home .contact-icon {
  font-size: 12px;
  margin-right: 10px;
}

.employee-home .user-icon {
  width: 60px;
  height: 60px;
  object-fit: contain;
  border-radius: 100%;
}

.bold-color {
  color: #333;
}

.employee-home .top-header {
  min-height: 60px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 30px 0px 30px;
}

.company-logo {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 100%;
}

.employee-home .search {
  padding: 10px !important;
  border-radius: 40px !important;
  padding-left: 40px !important;
  background-color: #f6f6f6;
  border: none !important;
  min-width: 400px !important;
}

.employee-home .search-wrapper {
  position: relative;
}

.employee-home .search-icon {
  position: absolute;
  left: 10px;
  top: 8px;
}

.employee-home .small-icon {
  width: 25px;
  height: 25px;
}

.employee-home .notification {
  position: relative;
}

.employee-home .user-options {
  border-left: 0.75px solid #d8dde4;
  padding: 20px;
}

.employee-home .mid-header {
  background-color: var(--deep-blue);
}

.employee-home .user-settings {
  padding: 0px 30px 0px 30px;
  color: #fff;
  display: flex;
  align-items: center;
}

.employee-home .user-image {
  width: 170px;
  height: 170px;
  object-fit: cover;
  border-radius: 100%;
  margin-right: 25px;
  margin-bottom: -50px;
}

.employee-home .user-settings h2 {
  font-weight: bold;
  line-height: 33px;
  font-size: 18px;
  color: #ffffff;
}

.employee-home .settings {
  background-color: #fff;
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 3px;
  margin-left: auto;
  border-radius: 3px;
}

.employee-home .settings img {
  width: 40px;
  height: 40px;
  margin: 0;
}

.employee-home .bottom-header {
  min-height: 60px;
  background-color: #fff;
}

.current-link {
  position: absolute;
  bottom: -80px;
  font-size: 24px;
  color: #333;
}

/*  scrollbar */
.birthdays .card-body {
  height: 150px;
  overflow-y: scroll;
}

.birthdays .card-body::-webkit-scrollbar {
  width: 1em;
  margin-right: 10px;
}

.birthdays .card-body::-webkit-scrollbar-thumb {
  background-color: var(--blue);
  outline: 1px solid slategrey;
  border-radius: 50px;
  margin-right: 10px;
}

/* user switch dropdown */

@media screen and (max-width: 1150px) {
  .employee-home .grid {
    grid-template-columns: 30px 250px 1fr 30px;
  }
}

@media screen and (max-width: 1150px) {
  .employee-home .sidenav {
    display: none;
  }

  .employee-home .grid {
    grid-template-areas:
      "header header header"
      ".  main  .";
    grid-template-columns: 30px 1fr 30px;
  }
}

@media screen and (max-width: 860px) {
  .employee-home .main {
    grid-template-columns: 1fr;
  }

  .employee-home .smaller {
    display: grid;
    align-items: start;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 20px;
    grid-column: 1/-1;
  }

  .employee-home .bigger {
    grid-column: 1/-1;
  }

  .employee-home .user-image {
    width: 120px;
    height: 120px;
  }

  .employee-home .nav {
    justify-content: flex-start;
  }

  .current-link {
    bottom: -60px;
  }
}

.employee-home .nav.show {
  visibility: visible;
  opacity: 1;
  background-color: var(--deep-blue);
  z-index: 100;
  transform: translateX(0);
  opacity: 1;
  transition: all 300ms ease;
}

.employee-home .nav.show a {
  margin-bottom: 30px;
}

.employee-home .nav.show .close {
  display: block;
  position: fixed;
  z-index: 100;
  top: 20px;
  right: 9px;
}

/* Navigation on mobile */
@media screen and (max-width: 797px) {
  .employee-home .nav {
    display: block !important;
    visibility: hidden;
    opacity: 0;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: none;
    padding: 60px 0px 0px;
    transform: translateX(100%);
  }

  .employee-home .nav a {
    /* margin: 0px 0px 50px 0px; */
    font-size: 25px;
    padding: 10px;
  }

  .employee-home .nav .media-group {
    margin-left: 53%;
    transform: translateX(-50%);
  }

  .employee-home .nav a:hover,
  .employee-home .nav a.active {
    opacity: 0.5;
    transition: all 300ms ease;
  }

  .employee-home .nav a:after {
    display: none;
  }

  .employee-home .close.show {
    display: block;
    position: fixed;
    z-index: 100;
  }

  body {
    height: 100vh;
  }

  .mid-header {
    padding-top: 10px;
  }

  .employee-home .top-header {
    display: none;
  }

  .employee-home .grid .header {
    background-color: transparent;
  }

  .settings img,
  .current-link img {
    width: 20px;
    height: 20px;
  }

  .current-link {
    font-size: 15px;
  }

  .mobile {
    display: block;
  }
}

@media screen and (max-width: 750px) {
  .employee-home .smaller {
    grid-template-columns: 1fr;
  }

  .employee-home .main {
    margin: 20px 0;
  }
}

@media screen and (max-width: 500px) {
  .employee-home .user-settings {
    padding-bottom: 10px;
  }

  .employee-home .user-image {
    width: 40px;
    height: 40px;
    align-self: flex-start;
    margin-top: 12px;
  }

  .employee-home .bottom-header {
    display: none;
  }

  .employee-home .current-link {
    display: none;
  }

  .employee-home .header {
    min-height: auto;
  }

  .employee-home .grid {
    grid-template-columns: 15px 1fr 15px;
  }
}

@media screen and (max-width: 400px) {
  .employee-home .user-image {
    display: none;
  }

  .employee-home {
    font-size: 13px;
  }

  .small {
    font-size: 10px !important;
  }
}

body:not(_) {
  overflow-y: hidden !important;
}
</style>
